const recentErrors: string[] = []
const MAX_ERRORS = 10

const originalConsoleError = console.error
console.error = (...args: unknown[]) => {
  recentErrors.push(args.map(String).join(' '))
  if (recentErrors.length > MAX_ERRORS) recentErrors.shift()
  originalConsoleError.apply(console, args)
}

window.addEventListener('error', (e) => {
  recentErrors.push(`${e.message} at ${e.filename}:${e.lineno}:${e.colno}`)
  if (recentErrors.length > MAX_ERRORS) recentErrors.shift()
})

window.addEventListener('unhandledrejection', (e) => {
  recentErrors.push(`Unhandled rejection: ${e.reason}`)
  if (recentErrors.length > MAX_ERRORS) recentErrors.shift()
})

export function getRecentConsoleErrors(): string[] {
  return [...recentErrors]
}
